module.exports = __webpack_public_path__ + "static/media/shopBannerMob.a8e65bf5.png";